import VariationUser from './VariationUser';

export class Variation {
  public id: string;
  public pv: number;
  public cv: number;
  public score: string;
  public formattedScore: number;
  public screenshotImage: string;
  public user: VariationUser;
  public paused: boolean;

  constructor({
    id,
    pv,
    cv,
    score,
    screenshot_image,
    user,
    paused,
  }: {
    id: string;
    pv: number;
    cv: number;
    score: string;
    screenshot_image: string;
    user: VariationUser;
    paused: boolean;
  }) {
    this.id = id;
    this.pv = pv;
    this.cv = cv;
    this.score = score;
    this.screenshotImage = screenshot_image;
    this.user = user;
    this.paused = paused;

    const variationScore = score === '0.0' ? 1.0 : Number(score);
    this.formattedScore = Math.floor(variationScore * 1000) / 10;
  }
}

export default Variation;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/domain/entity/Variation.ts